import React, {useState} from 'react';
import {Box, Button, FormControl, Input, InputLabel, Typography, FormHelperText} from '@deere/fuel-react';
import {ModalDialog} from "../shared/ModalDialog";
import {ADD_COMMENT_TITLE, EDIT_COMMENT} from "../shared/Constants";

export const RatingsAddComment = ({
                                      criteriaComment,
                                      criteriaId,
                                      isEdit = false,
                                      placeholder,
                                      onCommentsAction,
                                      type
                                  }) => {
    const [characterCount, setCharacterCount] = useState(criteriaComment ? criteriaComment.comment.length : 0);
    const [value, setValue] = useState(criteriaComment && criteriaComment.comment);
    const [error, setError] = useState("");

    const onCancel = () => {
        onCommentsAction("", "", "cancel")
    }

    const onSubmit = () => {
        if(value){
            if (isEdit){
                if(type === "categoryComment")
                    onCommentsAction(value, criteriaId, "update", criteriaComment.id)
                else
                onCommentsAction(value, criteriaComment.id, "update")
            }   
            else
                onCommentsAction(value, criteriaId, "save")
        }else{
            setError("Please Enter Comments")
        }
    }

    const onDelete = () => {
        if(type === "categoryComment")
            onCommentsAction("", criteriaId, "delete", criteriaComment.id)
        else
            onCommentsAction("", criteriaComment.id, "delete")
    }

    return (
        <FormControl fullWidth>
            <InputLabel htmlFor="comment">
                {isEdit ? EDIT_COMMENT : ADD_COMMENT_TITLE}
                <span style={{
                    marginLeft: ".25rem",
                    display: "inline"
                }}
                      aria-label="required field"
                      className="uxf-is-required"
                > * </span>
            </InputLabel>
            <Input
                onChange={(e) => {
                    setError("");
                    setCharacterCount(e.target.value.length)
                    setValue(e.target.value)
                }}
                defaultValue={criteriaComment && criteriaComment.comment}
                label={"Text Value"}
                multiline={true}
                aria-multiline={true}
                placeholder={placeholder}
                minRows={4}
                rowsMin={4}
                inputProps={
                    {maxLength: 750}
                }/>
            <Box display="flex" justifyContent="flex-start">
                <Typography variant="caption" color="secondary" component="p">
                    {characterCount} / 750
                </Typography>
            </Box>
            <FormHelperText error={error !== ""} style={{padding: ".5rem"}}>{error}</FormHelperText>
            <Box display="flex" justifyContent="flex-end">
                {isEdit &&
                <ModalDialog
                    titleText={"Delete Comment"}
                    content={<React.Fragment>Are you sure you want to delete this
                        Comment?</React.Fragment>}
                    saveButtonText={"Delete"}
                    onSave={onDelete}
                    page={"Ratings"}
                />
                }
                <Button variant="secondary" style={{marginRight: ".5rem"}} size="medium" onClick={() => {
                    onCancel()
                }}>Cancel</Button>
                <Button variant="primary" size="medium" type="submit"
                        onClick={() => onSubmit()}
                >Save</Button>
            </Box>
        </FormControl>
    )
}
